module.exports = __webpack_public_path__ + "static/media/economics.24e9bb04.png";